export default "__VITE_ASSET__353645ec__"